import { render, staticRenderFns } from "./TaskAssignDialog.vue?vue&type=template&id=1be65956&scoped=true"
import script from "./TaskAssignDialog.vue?vue&type=script&lang=js"
export * from "./TaskAssignDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskAssignDialog.vue?vue&type=style&index=0&id=1be65956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be65956",
  null
  
)

export default component.exports